import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  deactivation: state.user.activeDeactivation,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:deactivationDetailController
 * @description
 * # deactivationDetailController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('deactivationDetailController', ($ngRedux, $scope, $rootScope, $timeout, $http, ENV, $interval) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.close = () => {
      $rootScope.isDeactivationDetailDisplay = false;
      $rootScope.closeComponent();
    };

    $scope.generateUserRoute = () => {
      return `${$rootScope.routes.user}/${$scope.user.id}`;
    };

    let deactivationPromise;
    $scope.pollDeactivationStatus = () => {
      // if promise exists, cancel it to prevent duplication of intervals
      if (angular.isDefined(deactivationPromise)) {
        $interval.cancel(deactivationPromise);
        deactivationPromise = undefined;
      }
      deactivationPromise= $interval(() => {
        $scope.getDeactivationStatus();
      }, 6000);
    }

    $scope.getDeactivationStatus = () => {
      $scope
      .getDeactivation($http, ENV, $rootScope.userId, $scope.deactivation.id)
      .then((res) => {
        $scope.$apply(() => {
          $scope.checkDeactivationStatus();
        });
      });
    };

    $scope.checkDeactivationStatus = () => {
      if (!$scope.deactivation.deactivation_completed){
        $scope.pollDeactivationStatus();
      } else if ($scope.deactivation.deactivation_completed) {
        $interval.cancel(deactivationPromise);
        $rootScope.refreshLoyaltyStatistics();
        $rootScope.getData();
        $scope.getUser($http, ENV, $rootScope.userId);
      }
    }

    const userIdListener = $rootScope.$watch('isDeactivationDetailDisplay', () => {
      if ($rootScope.isDeactivationDetailDisplay && $rootScope.userId) {
        $scope.checkDeactivationStatus();
      }
    });

    $scope.init();

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      $interval.cancel(deactivationPromise);
      userIdListener();
    });
  })
  .directive('deactivationDetail', () => {
    return {
      templateUrl: 'templates/v2/deactivation-detail.html',
    };
  });
